import request from "@/utils/request";
import axios from "axios";

// 保存大屏设计
export function insertDashboard(data) {
  return request({
    url: "/report-dashboard/save",
    method: "post",
    data,
  });
}
// 预览、查询大屏详情
export function detailDashboard(data) {
  // return detailDashboardMockData;
  return request({
    url: "/report-dashboard/view",
    method: "post",
    data,
  });
}
// 获取动态数据
export function getData(data) {
  return request({
    url: "/report-dashboard/getData",
    method: "post",
    data,
  });
}
// 数据集查询
export function queryAllDataSet(data) {
  return request({
    url: "/report-dashboard/report-data-set/list",
    method: "post",
    data,
  });
}
// 获取数据集信息
export function detailBysetId(data, bd) {
  return request({
    url: "/report-dashboard/report-data-set/detailBysetId/" + data,
    method: "post",
    data: bd,
  });
}
// 通过 setCode 获取数据集详情（包含最新脚本）
export function getDataSetDetailByCode(setCode) {
  return request({
    url: "/report-dashboard/detailBysetCode/" + setCode,
    method: "post",
  });
}
// 导出大屏
export function exportDashboard(data) {
  return new Promise((resolve) => {
    axios({
      method: "get",
      url: "/report-dashboard/export",
      params: data,
      responseType: "blob",
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        resolve("error");
      });
  });
}
// 导入大屏
export function importDashboard(data) {
  return request({
    url: "/report-dashboard/import",
    method: "get",
    data,
  });
}
